import Image from "next/image";
import CocoImg from "public/assets/profile-created.png";
import React from "react";
import {
  ContentBox,
  ContentSubtitle,
  ContentTitle,
  IllustrationWrapper,
  ImageContentWrapper,
  ModalContainer,
  ModalHeader,
  ModalOverlay,
  ModalSubHeader,
  SelectScheduleCTA,
  SelectScheduleWrapper
} from "./profile-created.styles";
import { ProfileCreatedProps } from "./profile-created.types";

const ProfileCreated: React.FC<ProfileCreatedProps> = ({
  onSelectSchedule
}) => {
  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>Yeay! profilmu udah lengkap nih 🤩</ModalHeader>
        <ModalSubHeader>
          Seneng banget, sebentar lagi ketemu di kelas!
        </ModalSubHeader>
        <ImageContentWrapper>
          <IllustrationWrapper>
            <Image src={CocoImg} alt="Celebration Illustration" />
          </IllustrationWrapper>

          <ContentBox>
            <ContentTitle>
              Selanjutnya pilih <br /> jadwal yang sesuai ya
            </ContentTitle>
            <ContentSubtitle>
              Pilih jadwal yang nggak bentrok sama aktivitasmu yang lain 😉
            </ContentSubtitle>
            <SelectScheduleWrapper>
              <SelectScheduleCTA
                type="submit"
                disabled={false}
                variant="primary"
                data-testid="select-schedule-button"
                onClick={onSelectSchedule}
              >
                Pilih Jadwal
              </SelectScheduleCTA>
            </SelectScheduleWrapper>
          </ContentBox>
        </ImageContentWrapper>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ProfileCreated;
